import { useTranslation } from "react-i18next";
import {
	FrontendUserInfo,
	FrontendAnalystViewSampleWithInstanceAndSpec,
	FrontendCompanyWithAdditionalInfomation,
	FrontendCompanyTestCategory,
} from "node-library/dist/portal";
import { OrderTableSortColumn, SortOrder } from "node-library/dist/paginations";
import { NeutralColor } from "node-library/dist/colors";
import { useEffect, useState } from "react";
import { FrontendContentPage } from "node-library/dist/constants";
import AnalystViewInstancesTableListView from "./analystViewInstancesTableListView";

interface Props {
	company: FrontendCompanyWithAdditionalInfomation;
	selectedCategory: FrontendCompanyTestCategory;
	instances: Array<FrontendAnalystViewSampleWithInstanceAndSpec>;
	user: FrontendUserInfo | undefined;
	// sortBy: OrderTableSortColumn;
	// setSortBy: React.Dispatch<React.SetStateAction<OrderTableSortColumn>>;
	// sortOrder: SortOrder;
	// setSortOrder: React.Dispatch<React.SetStateAction<SortOrder>>;

	navigateToInstanceDetailsPage: (
		instanceId: string,
		fromPage: FrontendContentPage
	) => void;
}

export default function AnalystViewInstancesContent(props: Props) {
	const { t: translation } = useTranslation();

	const {
		instances,
		company,
		// sortBy,
		// setSortBy,
		// sortOrder,
		// setSortOrder,
		navigateToInstanceDetailsPage,
	} = props;

	const [isMobile, setIsMobile] = useState(false);

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth < 600);
		};

		// Set the initial screen size on mount
		handleResize();

		// Listen for window resize
		window.addEventListener("resize", handleResize);

		// Clean up the event listener
		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);

	return (
		<div style={{ flex: "1 1 0%", position: "relative" }}>
			{instances.length === 0 ? (
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						alignItems: "center",
						position: "absolute",
						left: "50%",
						top: "50%",
						transform: "translate(-50%, -50%)",
						gap: "5px",
					}}
				>
					<div className="no-order-icon"></div>

					<div
						className="typography-body-01 typography-bold"
						style={{ marginTop: "20px" }}
					>
						{translation("NoSampleInstance")}
					</div>
					<div
						className="typography-body-02"
						style={{ color: NeutralColor.NEUTRAL_GREY_500 }}
					>
						{translation("NoInstanceDescription")}
					</div>
				</div>
			) : (
				// isMobile ? (
				// 	// <AdminViewOrdersTableGridView
				// 	// 	orders={orders}
				// 	// 	user={props.user}
				// 	// 	deleteOrder={deleteOrder}
				// 	// 	viewOrderCOC={viewOrderCOC}
				// 	// 	goToViewOrderDetails={goToViewOrderDetails}
				// 	// 	setDiscardOrderConfirmOpen={setDiscardOrderConfirmOpen}
				// 	// 	setProceedAction={setProceedAction}
				// 	// />
				// 	<></>
				// ) : (
				// 	<AnalystViewInstancesTableListView
				// 		instances={instances}
				// 		user={props.user}
				// 		navigateToInstanceDetailsPage={navigateToInstanceDetailsPage}
				// 	/>
				// )
				<AnalystViewInstancesTableListView
					company={company}
					selectedCategory={props.selectedCategory}
					instances={instances}
					user={props.user}
					navigateToInstanceDetailsPage={navigateToInstanceDetailsPage}
				/>
			)}
		</div>
	);
}
